// extracted by mini-css-extract-plugin
export default {"footerArea":"Footer_footerArea__uHP3G","title":"Footer_title__-rzTJ","content":"Footer_content__1dXVD"};